'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var sessionStore = require('./sessionStore.js');
require('./tslib.es6-cd939937.js');
require('./memoryStorage.js');
require('./_storageService-4a3804f6.js');

var SessionCache = /** @class */ (function () {
    function SessionCache(defaultLifeTime, storePrefix) {
        if (defaultLifeTime === void 0) { defaultLifeTime = 7200000; }
        if (storePrefix === void 0) { storePrefix = null; }
        this.defaultLifeTime = defaultLifeTime;
        this.sessionStore = new sessionStore.SessionStore(storePrefix);
    }
    Object.defineProperty(SessionCache.prototype, "now", {
        get: function () {
            return Math.round(Date.now() / 1000);
        },
        enumerable: false,
        configurable: true
    });
    SessionCache.prototype.isExpired = function (record) {
        return record && record.expires && record.expires < this.now;
    };
    SessionCache.prototype.get = function (key) {
        var val = this.sessionStore.get(key);
        if (val && val.expires > this.now) {
            return val.value;
        }
        if (val) {
            this.expire(key);
        }
        return null;
    };
    SessionCache.prototype.set = function (key, value, lifeTimeMS) {
        if (lifeTimeMS === void 0) { lifeTimeMS = this.defaultLifeTime; }
        return this.sessionStore.set(key, {
            expires: (lifeTimeMS / 1000) + this.now,
            value: value
        });
    };
    SessionCache.prototype.clean = function (force) {
        if (force === void 0) { force = false; }
        var records = this.sessionStore.getAll();
        for (var key in records) {
            if (key.indexOf(this.sessionStore.prefix) !== -1 && records[key] && records[key].expires && records[key].value && (force || this.isExpired(records[key]))) {
                this.sessionStore.delete(key);
            }
        }
        return true;
    };
    SessionCache.prototype.expire = function (key) {
        var _this = this;
        // @ts-ignore
        if (Array.isArray(key)) {
            key.map(function (k) {
                _this.sessionStore.delete(k);
            });
            return true;
        }
        return this.sessionStore.delete(key);
    };
    return SessionCache;
}());
var sessionCache = new SessionCache();

exports.SessionCache = SessionCache;
exports.sessionCache = sessionCache;
